import { defineStore } from "pinia";
import { useAuthStore } from "./auth";

export const useRoomStore = defineStore("room", () => {
  const roomList = ref([]);
  const hubDialog = ref(null);

  const setRoomList = (rooms) => {
    roomList.value = rooms;
  };

  return { roomList, hubDialog, setRoomList };
});
